import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress
} from '@mui/material';

import { deepPurple } from '@mui/material/colors';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { toast } from 'react-toastify';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import * as XLSX from 'xlsx';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 600,
    minWidth: '800px',
    // width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const columns = [
    { id: 'id', label: 'ID', minWidth: 30 },
    // { id: 'referrerCustomerID', label: 'Referrer Customer ID', minWidth: 120 },
    { id: 'referrerCustomerName', label: 'Referrer Customer Name', minWidth: 170 },
    { id: 'referrerCustomerLoginUserName', label: 'Referrer Login User Name', minWidth: 170 },
    // { id: 'refereeCustomerID', label: 'Referee Customer ID', minWidth: 170 },
    { id: 'refereeCustomerName', label: 'Referee Customer Name', minWidth: 170 },
    { id: 'refereeCustomerLoginUserName', label: 'Referee Login User Name', minWidth: 170 },
    {
        id: 'statusName',
        label: 'Status Name',
        minWidth: 140
    },
    // {
    //     id: 'stageLevel',
    //     label: 'Stage Level',
    //     minWidth: 120
    // },
    {
        id: 'bonusPercentage',
        label: 'Bonus Percentage',
        minWidth: 170
    },
    {
        id: 'bonusGiven',
        label: 'Bonus Given',
        minWidth: 170
    },     
    { id: 'payoutDate', label: 'Payout Date', minWidth: 170 },
    { id: 'miningBonusGiven', label: 'Mining Bonus Given', minWidth: 170 },
    {
        id: 'bankVendorName',
        label: 'Bank Vendor Name',
        minWidth: 170
    },
    {
        id: 'bankAccountNumber',
        label: 'Bank Account Number',
        minWidth: 170
    },
    {
        id: 'bankAccountHolderName',
        label: 'Bank Account Holder Name',
        minWidth: 170
    },
    // {
    //     id: 'payoutThirdPartyName',
    //     label: 'Payout Third Party Name',
    //     minWidth: 190
    // },
    {
        id: 'createdBy',
        label: 'Created By',
        minWidth: 170
    },
    {
        id: 'createdDate',
        label: 'Created Date',
        minWidth: 190,
        type: 'date'
    }
    // {
    //     id: 'requestDate',
    //     label: 'Request Date',
    //     minWidth: 190,
    //     type: 'date'
    // },
    // {
    //     id: 'payoutDate',
    //     label: 'Payout Date',
    //     minWidth: 190,
    //     type: 'date'
    // }
];

const ReferralDetails = () => {
    const token = useSelector(selectCurrentToken);
    const [referralDetails, setReferralDetails] = useState([]);
    const [filterReferralDetailsFrom, setFilerReferralDetailsFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterReferralDetailsTo, setFilerReferralDetailsTo] = useState(dayjs());
    const [refereeName, setRefereeeName] = useState('');
    const [referrerName, setReferrerName] = useState('');
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [isAllowFilterUserName, setIsAllowFilterUserName] = useState();
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);
    const [refereeLoginUserName, setRefereeeLoginUserName] = useState('');
    const [referrerLoginUserName, setReferrerLoginUserName] = useState('');

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };
    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const [page, setPage] = useState(0);
    useEffect(() => {
        const savedPage = localStorage.getItem('currentPage');
        if (savedPage !== null) {
            setPage(parseInt(savedPage, 10));
        } else {
            setPage(0);
        }
    }, []);
    localStorage.setItem('currentPage', 0);

    //fetch currency start
    const fetchCurrency = async () => {
        try {
            const res = await axiosInstance.get('/Currency', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setCurrencies(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch currency end

    //fetch currency start
    const [updateThirdPartyList, setUpdateThirdPartyList] = useState([]);
    const fetchThirdParty = async () => {
        try {
            const res = await axiosInstance.get('/ThirdParty', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setUpdateThirdPartyList(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch currency end

    //fetch Referral Details start
    const [fetchReferralDetailsLoading, setFetchReferralDetailsLoading] = useState(false);
    const fetchReferralDetails = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);

        if (!filterReferralDetailsFrom.isValid() || !filterReferralDetailsTo.isValid()) {
            warningAlert('Please fill/All all required fields.');
            return;
        }
        let referralURL = `/ReferralDetails/All?refereeRegisteredFromDate=${filterReferralDetailsFrom.format(
            'YYYY-MM-DD'
        )}&refereeRegisteredToDate=${filterReferralDetailsTo.format('YYYY-MM-DD')}`;

        if (refereeName !== '') {
            referralURL += `&refereeName=${refereeName}`;
        }
        if (referrerName !== '') {
            referralURL += `&referrerName=${referrerName}`;
        }
        if (refereeLoginUserName !== '') {
            referralURL += `&refereeLoginUserName=${refereeLoginUserName}`;
        }
        if (referrerLoginUserName !== '') {
            referralURL += `&referrerLoginUserName=${referrerLoginUserName}`;
        }

        if (filterReferralUsername !== '') {
            referralURL += `&searchUserID=${parseInt(filterReferralUsername, 10)}`;
        }
        if (filterStatusName !== '') {
            referralURL += `&statusID=${parseInt(filterStatusName)}`;
        }
        if (filterHasBonusGiven !== '') {
            referralURL += `&isFilterHasBonusGiven=${filterHasBonusGiven}`;
        }
        setFetchReferralDetailsLoading(true);
        try {
            const res = await axiosInstance.get(referralURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setReferralDetails(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchReferralDetailsLoading(false);
        }
    };
    //fetch Referral Details end

    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);
        if (!filterReferralDetailsFrom.isValid() || !filterReferralDetailsTo.isValid()) {
            warningAlert('Please fill/All all required fields.');
            return;
        }
        let referralURL = `/ReferralDetails/All?refereeRegisteredFromDate=${filterReferralDetailsFrom.format(
            'YYYY-MM-DD'
        )}&refereeRegisteredToDate=${filterReferralDetailsTo.format('YYYY-MM-DD')}`;

        if (refereeLoginUserName !== '') {
            referralURL += `&refereeLoginUserName=${refereeLoginUserName}`;
        }
        if (referrerLoginUserName !== '') {
            referralURL += `&referrerLoginUserName=${referrerLoginUserName}`;
        }

        if (filterReferralUsername !== '') {
            referralURL += `&searchUserID=${parseInt(filterReferralUsername, 10)}`;
        }
        if (filterStatusName !== '') {
            referralURL += `&statusID=${parseInt(filterStatusName)}`;
        }
        
        if (filterHasBonusGiven !== '') {
            referralURL += `&isFilterHasBonusGiven=${filterHasBonusGiven}`;
        }

        try {
            const res = await axiosInstance.get(referralURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `ReferralDetails_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(res.data);
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };

    const fetchIsAllowFilterUserName = async () => {
        try {
            const res = await axiosInstance.get(`/isAllowFilterUserName`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setIsAllowFilterUserName(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const [referralStatusList, setReferralStatusList] = useState([]);
    const fetchReferralStatus = async () => {
        try {
            const res = await axiosInstance.get('/Referral/Status/All', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setReferralStatusList(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const [customerLoginUserNameOptions, setCustomerLoginUserNameOptions] = useState([]);
    const fetchCustomerLoginUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/LoginUserNames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setCustomerLoginUserNameOptions(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    fetchReferralDetails(),
                    fetchCurrency(),
                    fetchThirdParty(),
                    fetchIsAllowFilterUserName(),
                    fetchReferralStatus(),
                    fetchThirdPartyDropdownList(),
                    fetchCustomerLoginUserNamesOptions()
                ]);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    //Referral table start
    function StickyHeadTable() {
        const [rowsPerPage, setRowsPerPage] = useState(() => {
            const storedRowsPerPage = localStorage.getItem('rowsPerPage');
            return storedRowsPerPage ? parseInt(storedRowsPerPage, 10) : 100;
        });

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            const newRowsPerPage = +event.target.value;
            setRowsPerPage(newRowsPerPage);
            setPage(0);
            localStorage.setItem('rowsPerPage', newRowsPerPage.toString());
        };

        useEffect(() => {
            localStorage.setItem('rowsPerPage', rowsPerPage.toString());
        }, [rowsPerPage]);

        return (
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {referralDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (column.type && column.type === 'date') {
                                                if (value) {
                                                    const timeString12hr = new Date(
                                                        '1970-01-01T' + value.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    });
                                                    value = `${value.split('T')[0]} ${timeString12hr}`;
                                                }
                                            }
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </TableCell>
                                            );
                                        })}
                                        {isUserAllowEdit &&
                                            <TableCell>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px'
                                                    }}
                                                >
                                                    {/* <ViewDetailsModal id={row.id} /> */}
                                                    <UpdateReferralDetails page={page} setPage={setPage} referralDetails={row} />
                                                </Box>
                                            </TableCell>
                                        }
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={referralDetails.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
    //Referral table end

    const [usersList, setUsersList] = useState([]);
    const [filterReferralUsername, setFilterReferralUsername] = useState('');
    const [filterStatusName, setFilterStatusName] = useState('');
    const [filterHasBonusGiven, setFilterHasBonusGiven] = useState('true');
    //fetch customer names for autocomplete start
    const fetchUserNamesOption = async () => {
        try {
            const res = await axiosInstance.get('/Usernames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUsersList(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    const [thirdPartyList, setThirdPartyList] = useState([]);
    const [thirdPartyListLoading, setThirdPartyListLoading] = useState(false);
    const fetchThirdPartyDropdownList = async () => {
        setThirdPartyListLoading(true);
        try {
            const res = await axiosInstance.get('/ThirdPartyTransactionLimit/AvailableOptions', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setThirdPartyList(res.data);
            } else {
                errorAlert('Something Went Wrong');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setThirdPartyListLoading(false);
        }
    };

    const UpdateReferralDetails = ({ referralDetails, page, setPage }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [updatedPayoutThirdPartyID, setUpdatedPayoutThirdPartyID] = useState('');
        const [updatedStatus, setUpdatedStatus] = useState('');

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updateReferralDetailsLoading, setUpdateReferralDetailsLoading] = useState(false);

        const submitUpdateReferalDetails = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            if (updatedPayoutThirdPartyID === '' || updatedStatus === '') {
                warningAlert('Please fill all required fields.');
                return;
            }
            setUpdateReferralDetailsLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/ReferralDetails/Status',
                    {
                        Id: parseInt(referralDetails.id),
                        statusID: parseInt(updatedStatus),
                        payoutThirdPartyID: parseInt(updatedPayoutThirdPartyID)
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    localStorage.setItem('currentPage', page);
                    setOpen(false);
                    fetchReferralDetails();
                    successAlert('Referral Details updated successfully.');
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateReferralDetailsLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updateReferralDetailsLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Update Referral Details
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '300px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Payout Third Party ID :
                                            </Typography>

                                            <Select
                                                displayEmpty
                                                value={updatedPayoutThirdPartyID}
                                                onChange={(e) => setUpdatedPayoutThirdPartyID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Third Party
                                                </MenuItem>
                                                {updateThirdPartyList.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Status :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updatedStatus}
                                                onChange={(e) => setUpdatedStatus(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Status
                                                </MenuItem>
                                                {referralStatusList.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdateReferalDetails()}
                                disabled={updateBtnDisabled}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };

    // Batch Update Start
    const BatchApprove = ({ refereeLoginUserName, referrerLoginUserName }) => {
        const [batchStartDate, setBatchStartDate] = useState('');
        const [batchEndDate, setBatchEndDate] = useState('');
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false); // Initialize as false
        const [loading, setLoading] = useState(false); // Add loading state

        const submitInsertBatchUpdateDate = async () => {
            if (batchStartDate === '' || batchEndDate === '') {
                warningAlert('Please fill all required fields.');
                return;
            }

            setLoading(true); // Set loading to true
            setInsertBtnDisabled(true); // Disable the button during submission

            const formattedBatchStartDate = dayjs(batchStartDate).format('YYYY-MM-DD');
            const formattedBatchEndDate = dayjs(batchEndDate).format('YYYY-MM-DD');

            try {
                const res = await axiosInstance.post(
                    '/BatchUpdate/ReferralDetails',
                    {
                        dateFrom: formattedBatchStartDate,
                        dateTo: formattedBatchEndDate,
                        refereeLoginUserName: refereeLoginUserName,
                        referrerLoginUserName: referrerLoginUserName
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    handleClose(); // Close the modal on success
                    fetchReferralDetails();
                    successAlert('Batch Update Success.');
                } else {
                    errorAlert('Something went wrong');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false); // Reset loading state after request is completed
                setInsertBtnDisabled(false); // Re-enable the button
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginBottom: '20px',
                        marginRight: '20px',
                        marginTop: '20px'
                    }}
                >
                    Batch Update
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Batch Update
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box id="modal-modal-description" sx={{}}>
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Start Date :
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={batchStartDate}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setBatchStartDate(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                End Date :
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={batchEndDate}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setBatchEndDate(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertBatchUpdateDate()}
                                disabled={insertBtnDisabled}
                            >
                                Update Batch
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    // Batch Update End

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([fetchUserNamesOption(), fetchIsUserAllowEdit()]);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Grid container item xs={12}>
            {isUserAllowEdit &&
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
                    <BatchApprove refereeLoginUserName={refereeLoginUserName} referrerLoginUserName={referrerLoginUserName} />
                </Box>
            }

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterReferralDetailsFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerReferralDetailsFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterReferralDetailsTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerReferralDetailsTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Referee Name :
                        </Typography>
                        <Autocomplete
                            freeSolo
                            value={refereeLoginUserName}
                            onChange={(event, newValue) => {
                                setRefereeeLoginUserName(newValue);
                            }}
                            inputValue={refereeLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setRefereeeLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerLoginUserNameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                color: isAllowFilterUserName ? '' : 'grey'
                            }}
                        >
                            Created By :
                        </Typography>

                        <Select
                            disabled={!isAllowFilterUserName}
                            displayEmpty
                            value={filterReferralUsername}
                            onChange={(e) => setFilterReferralUsername(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Username
                            </MenuItem>
                            {usersList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.userID} key={index}>
                                    {item.userName}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                color: isAllowFilterUserName ? '' : 'grey'
                            }}
                        >
                            Referrer Name :
                        </Typography>

                        <Autocomplete
                            freeSolo
                            value={referrerLoginUserName}
                            onChange={(event, newValue) => {
                                setReferrerLoginUserName(newValue);
                            }}
                            inputValue={referrerLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setReferrerLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerLoginUserNameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                color: isAllowFilterUserName ? '' : 'grey'
                            }}
                        >
                            Status :
                        </Typography>

                        <Select
                            displayEmpty
                            value={filterStatusName}
                            onChange={(e) => setFilterStatusName(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Status
                            </MenuItem>
                            {referralStatusList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                color: isAllowFilterUserName ? '' : 'grey'
                            }}
                        >
                            Has Bonus Given :
                        </Typography>

                        <Select
                            displayEmpty
                            value={filterHasBonusGiven}
                            onChange={(e) => setFilterHasBonusGiven(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Has Bonus Given
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="true">
                                True
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="false">
                                False
                            </MenuItem>
                        </Select>
                    </Box>
                </Grid>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: '15px',
                        width: '50%',
                        marginLeft: 'auto'
                    }}
                >
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => fetchReferralDetails()}
                        disabled={filterBtnDisabled}
                    >
                        Filter
                    </Button>
                    
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => exportDataAsXlsx()}
                        disabled={filterBtnDisabled}
                    >
                        Export Data
                    </Button>
                </Box>
            </Grid>
            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchReferralDetailsLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StickyHeadTable />
                )}
            </Box>
        </Grid>
    );
};

export default ReferralDetails;
